import { render, staticRenderFns } from "./pushTagList.vue?vue&type=template&id=12bf6a32"
import script from "./pushTagList.vue?vue&type=script&lang=js"
export * from "./pushTagList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports